import { render, staticRenderFns } from "./ConfirmText.vue?vue&type=template&id=5198c15a&"
import script from "./ConfirmText.vue?vue&type=script&lang=js&"
export * from "./ConfirmText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports